import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenGroupsAllComponent } from "./components/loren-groups-all/loren-groups-all.component";
import { LorenGroupsRoutingModule } from "./loren-groups-routing.module";
import { LorenCardModule } from "../../shared/modules/loren-card/loren-card.module";
import { LorenKeyValueControlModule } from "../../shared/modules/loren-key-value-control/loren-key-value-control.module";
import { LorenDatePipe } from "../../shared/pipes/loren-date/pipes/loren-date.pipe";
import { LorenEntityFormCardModule } from "../../shared/modules/loren-entity-form-card/loren-entity-form-card.module";
import { LorenEntityDeleteCardModule } from "../../shared/modules/loren-entity-delete-card/loren-entity-delete-card.module";
import { LorenAllGroupsResolver } from "./resolvers/loren-all-groups.resolver";
import { LorenHierarchySelectorModule } from "../../shared/modules/loren-hierarchy-selector/loren-hierarchy-selector.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";

@NgModule({
  declarations: [LorenGroupsAllComponent],
  providers: [
    LorenDatePipe,
    LorenAllGroupsResolver,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
    LorenGroupsRoutingModule,
    LorenCardModule,
    LorenKeyValueControlModule,
    LorenEntityFormCardModule,
    LorenEntityDeleteCardModule,
    LorenHierarchySelectorModule,
    LorenPageContentComponent,
  ],
})
export class LorenGroupsModule {}
